@import '../../../../../constants/spacing.module.less';

.step-info {
  margin: @space-4 @space-0 @space-16 @space-0;
  text-align: left;
  color: var(--grey-900);
}
